import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';

interface DeluxeLogoProps {
    /** Scale of the SVG icon */
    iconSize?: number;
    /** Show the text lockup below/beside the icon */
    showText?: boolean;
    /** 'stacked' = icon above text, 'inline' = icon left of text */
    layout?: 'stacked' | 'inline';
}

export function DeluxeLogo({ iconSize = 32, showText = true, layout = 'inline' }: DeluxeLogoProps) {
    const icon = (
        <SvgIcon sx={{ width: iconSize, height: iconSize, flexShrink: 0 }} viewBox="0 0 118 118">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g fill="#E31F2E">
                    <path d="M59.6175,0.1289 C26.9385,0.1309 0.4535,26.6169 0.4515,59.2939 C0.4535,91.9719 26.9385,118.4569 59.6175,118.4589 L62.7005,118.4589 L62.7005,37.9729 L62.6965,34.8929 L59.6105,37.9759 L59.6095,37.9729 L36.3795,61.2029 L40.7395,65.5649 L56.5335,49.7719 L56.5335,112.3259 C43.0845,111.5559 30.9945,105.8019 22.0495,96.8609 C12.4305,87.2369 6.4905,73.9749 6.4885,59.2939 C6.4905,44.6139 12.4305,31.3509 22.0495,21.7279 C31.6735,12.1079 44.9365,6.1679 59.6175,6.1659 C74.2975,6.1679 87.5605,12.1079 97.1835,21.7279 C106.8035,31.3519 112.7435,44.6139 112.7455,59.2939 C112.7435,70.8429 109.0685,81.5059 102.8195,90.2219 C96.5705,98.9369 87.7465,105.6829 77.4725,109.3479 L79.5015,115.0339 C90.9545,110.9469 100.7685,103.4399 107.7255,93.7399 C114.6825,84.0439 118.7835,72.1339 118.7815,59.2939 C118.7805,26.6169 92.2945,0.1309 59.6175,0.1289" />
                </g>
            </g>
        </SvgIcon>
    );

    if (!showText) {
        return icon;
    }

    if (layout === 'stacked') {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                {icon}
                <Box sx={{ textAlign: 'center' }}>
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 700, color: '#E31F2E', letterSpacing: 2, lineHeight: 1 }}
                    >
                        DELUXE
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.5 }}>
                        Dubbing Vendor Management System
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            {icon}
            <Box>
                <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 700, color: '#E31F2E', letterSpacing: 1, lineHeight: 1.1 }}
                >
                    DELUXE
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: 0.3 }}>
                    Dubbing Vendor Management System
                </Typography>
            </Box>
        </Box>
    );
}
